"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertMultilineTextToJSX = void 0;

const react_1 = __importDefault(require("react"));
/**
 * Converts every "\n" within a text to JSX tag <br/>. Returns an array of strings and <br/> elements.
 */


function convertMultilineTextToJSX(title) {
  let lines = title.split("\n");
  return lines.reduce((acc, line, index) => {
    acc.push(line);

    if (index !== lines.length - 1) {
      acc.push(react_1.default.createElement("br", {
        key: index
      }));
    }

    return acc;
  }, []);
}

exports.convertMultilineTextToJSX = convertMultilineTextToJSX;